import { useState, useEffect } from "react";
import { useGlobalContext } from "../../Context/GlobalContext";
import { Form } from "../../Components/form";
import { resetQueryParams } from "../../Utils/Window";
import { Logo } from "../../Components/logo";
import Notify from "../../Utils/Notify";
import { useNavigationContext } from "../../Context/NavigationContext";

const ResetPasswordView = () => {
    const { 
        dbManager,
    } = useGlobalContext();

    const {
        changeLandingView
    } = useNavigationContext();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        resetQueryParams()
        setCode(params.get("code") ?? "")
    }, [])

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [code, setCode] = useState("");

    const handleSubmit = async () => {
        if(password !== confirmPassword) {
            Notify("error", "Passwords do not match");
            return;
        }
        await dbManager.request('/user/newPassword', 'POST', {password, code});
        Notify("success", "Password changed sucessfully");
        changeLandingView('Login')
    }

    return (
        <div className="login" style={{width: '40%', margin: 'auto', marginTop: '3vh'}}>
        <Logo />
        <Form
            fields={[
                {
                    label: "NEW PASSWORD",
                    type: "password",
                    placeholder: "******",
                    setValue: setPassword,
                    value: password,
                    name: "password",
                },
                {
                    label: "CONFIRM NEW PASSWORD",
                    type: "password",
                    placeholder: "******",
                    setValue: setConfirmPassword,
                    value: confirmPassword,
                    name: "password",
                },
            ]}
            submit={handleSubmit}
            buttonText="SET NEW PASSWORD"
        />
        </div>
      );
}

export default ResetPasswordView;